import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
    },
    // debug: true,
    resources: {
      'en-US': {
        translation: {
          'manage-subscriptions': 'Manage Subscriptions',
          'send-emails-to': 'Emails sent to: ',
          'loading-message': 'Loading your subscriptions...',
          'show-more': 'Show more',
          'show-less': 'Show less',
          'unsubscribe-all': 'Unsubscribe from all',
          'confirmation-text': 'Are you sure you want to unsubscribe from all emails?',
          'confirm': 'Confirm',
          'email-invalid': 'Unable to load your subscriptions. Email address is not valid or you are not logged in.',
          'save-failed': 'Unable to save your subscriptions. Refreshing data',
          'unsubscribed-from-all': 'You are not receiving any subscriptions ([[EMAIL]])',
          'cancel': 'Cancel',
          'no-subs': 'No subscriptions found, please try again later.',
          'save': "Save preferences"
        },
      },
      'en-GB': {
        translation: {
          'manage-subscriptions': 'Manage Subscriptions',
          'send-emails-to': 'Emails sent to: ',
          'loading-message': 'Loading your subscriptions...',
          'show-more': 'Show more',
          'show-less': 'Show less',
          'unsubscribe-all': 'Unsubscribe from all',
          'confirmation-text': 'Are you sure you want to unsubscribe from all emails?',
          'confirm': 'Confirm',
          'email-invalid': 'Unable to load your subscriptions. Email address is not valid or you are not logged in.',
          'save-failed': 'Unable to save your subscriptions. Refreshing data',
          'unsubscribed-from-all': 'You are not receiving any subscriptions ([[EMAIL]])',
          'cancel': 'Cancel',
          'no-subs': 'No subscriptions found, please try again later.',
          'save': "Save preferences"
        }
      },
      'it-IT': {
        translation: {
          'manage-subscriptions': 'Gestione delle iscrizioni',
          'send-emails-to': 'Mail spedite a: ',
          'loading-message': 'Caricamento delle iscrizioni...',
          'show-more': 'Mostra di più',
          'show-less': 'Mostra di meno',
          'unsubscribe-all': 'Annulla l\'iscrizione',
          'confirmation-text': 'Sei sicuro di voler annullare l\'iscrizione a tutte le mail?',
          'confirm': 'Conferma',
          'email-invalid': 'Impossibile caricare le iscrizioni. Indirizzo mail o log in non validi.',
          'save-failed': 'Impossibile salvare le iscrizioni. Aggiornamento dei dati.',
          'unsubscribed-from-all': 'Non stai ricevendo le iscrizioni ([[EMAIL]])',
          'cancel': 'Annulla',
          'save': "Salva preferenze"
        }
      },
      'de-DE': {
        translation: {
          'manage-subscriptions': 'Abos verwalten',
          'send-emails-to': 'E-Mails an: ',
          'loading-message': 'Ihre Abos werden geladen...',
          'show-more': 'Mehr anzeigen',
          'show-less': 'Weniger anzeigen',
          'unsubscribe-all': 'Von allen abmelden',
          'confirmation-text': 'Sind Sie sicher, dass Sie sich von allen E-Mails abmelden möchten?',
          'confirm': 'Bestätigen',
          'email-invalid': 'Ihre Abos können nicht geladen werden. E-Mail-Adresse ist ungültig oder Sie sind nicht eingeloggt.',
          'save-failed': 'Ihre Abos können nicht gespeichert werden. Daten werden aufgefrischt',
          'unsubscribed-from-all': 'Sie erhalten keine Abos ([[EMAIL]])',
          'cancel': 'Stornieren',
          'save': "Auswahl speichern"
        }
      },
      'es-ES': {
        translation: {
          'manage-subscriptions': 'Gestionar suscripciones',
          'send-emails-to': 'E-mails enviados a: ',
          'loading-message': 'Cargando sus suscripciones...',
          'show-more': 'Mostrar más',
          'show-less': 'Mostrar menos',
          'unsubscribe-all': 'Darse de baja de todos',
          'confirmation-text': '¿Está seguro que quiere darse de baja de todos los correos electrónicos?',
          'confirm': 'Confirmar',
          'email-invalid': 'No se pueden cargar sus suscripciones. La dirección de correo electrónico no es válida o no ha iniciado sesión.',
          'save-failed': 'No se pueden guardar sus suscripciones. Actualizando datos',
          'unsubscribed-from-all': 'No está recibiendo ninguna suscripción ([[EMAIL]])',
          'cancel': 'Cancelar',
          'save': "Guardar Preferencias"
        }
      },
      'fr-FR': {
        translation: {
          'manage-subscriptions': 'Gestion de vos abonnements',
          'send-emails-to': 'Emails envoyés à: ',
          'loading-message': 'Affichage de vos abonnements en cours...',
          'show-more': 'Afficher la liste exhaustive',
          'show-less': 'Afficher la liste partielle',
          'unsubscribe-all': 'Se désincrire de l\'ensemble des notifications par email',
          'confirmation-text': 'Êtes-vous sûr(e) de vouloir vous désincrire de l\'ensemble des notifications par email?',
          'confirm': 'Confirmer',
          'email-invalid': 'Impossible d\'afficher vos abonnements. Cette adresse électronique n\'étant pas valable, vous êtes dans l\'incapacité de vous connecter.',
          'save-failed': 'Impossible de sauvegarder vos abonnements. Actualisation des données',
          'unsubscribed-from-all': 'Vous n\'êtes destinataire d\'aucun abonnement provenant de l\'adresse électronique ([[EMAIL]])',
          'cancel': 'Annuler',
          'save': "Enregistrer les préférences"
        }
      },
    },
  });

export default i18n;